import { ButtonFilled } from '@snack-uikit/button';
import { Typography } from '@snack-uikit/typography';
import cn from 'classnames';
import Image from 'next/image';

import { consoleMarketplaceUrl } from '../../global';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useFormatConsoleUrl } from '../../hooks/useFormatConsoleUrl';
import s from './MarketplaceMoreSolutionsBanner.module.scss';

const BANNER_CONTENT = {
  TITLE: 'Больше сервисов — в личном кабинете',
  DESCRIPTION:
    'Чтобы получить доступ ко всем сервисам Маркетплейса, перейдите в\u00a0консоль.',
  BUTTON_TEXT: 'В консоль',
};

interface MarketplaceMoreSolutionsBannerProps {
  isBannerAtTheEnd?: boolean;
}

export const MarketplaceMoreSolutionsBanner = ({
  isBannerAtTheEnd = false,
}: MarketplaceMoreSolutionsBannerProps) => {
  const logInUrl = useFormatConsoleUrl(
    consoleMarketplaceUrl,
    'banner',
    BANNER_CONTENT.BUTTON_TEXT,
  );
  const { clickAnalytics } = useAnalytics();

  return (
    <section className={cn(s.banner, isBannerAtTheEnd && s.end)} role="banner">
      <Typography
        className={s.title}
        tag="h3"
        purpose="title"
        family="sans"
        size="l"
      >
        {BANNER_CONTENT.TITLE}
      </Typography>
      <Typography
        tag="p"
        size="l"
        family="sans"
        purpose="body"
        className={s.description}
      >
        {BANNER_CONTENT.DESCRIPTION}
      </Typography>
      <ButtonFilled
        size="l"
        href={logInUrl}
        label="В консоль"
        appearance="primary"
        className={s.button}
        data-abt="banner-login"
        onClick={() => {
          clickAnalytics({
            action: 'click',
            clickZone: 'body',
            clickElement: 'button',
            clickContent: BANNER_CONTENT.BUTTON_TEXT,
            uniqueId: 'marketplace-banner-all-solutions',
            transitionType: 'inside-link',
          });
        }}
      />
      <Image
        alt=""
        width={328}
        height={232}
        aria-hidden={true}
        className={s.image}
        src="https://cdn.cloud.ru/backend/marketplace/images/watch_all_solutions.png"
      />
    </section>
  );
};
